import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

export const LeafSvg = ({ color }) => (
  <svg viewBox="0 0 40 60" className="h-full w-full" aria-hidden="true">
    <path d="M20 2C6 16 4 38 20 58 36 38 34 16 20 2Z" fill={color} />
    <path d="M20 8v48" stroke="rgba(255,255,255,.45)" strokeWidth="1.4" fill="none" />
  </svg>
);

export const Leaf = ({ className = "", color = "#1E5631", rotate = 0, drift = 40 }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], reduce ? [0, 0] : [drift, -drift]);
  const r = useTransform(scrollYProgress, [0, 1], reduce ? [rotate, rotate] : [rotate - 18, rotate + 18]);
  return (
    <motion.div
      ref={ref}
      aria-hidden="true"
      className={`pointer-events-none absolute ${className}`}
      style={{ y, rotate: r }}
      initial={{ opacity: 0, scale: 0.6 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
    >
      <LeafSvg color={color} />
    </motion.div>
  );
};

export const LeafIcon = ({ className = "h-4 w-3" }) => (
  <span className={`inline-block ${className}`}><LeafSvg color="#1E5631" /></span>
);
